import Vue from 'vue'
import Vuex from 'vuex'
import { user, app } from './modules'
import getters from './getters'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user
  }, 
   getters

})
